import { Injectable } from '@angular/core';


import { EditView } from '../base/edit-view';

@Injectable()
export class EditViewGuard  {
  constructor() { }

  async canDeactivate(component: EditView): Promise<boolean> {
    return true;
    // if (component.modified instanceof Promise) {
    //   component.modified.then(res => {
    //     return this.confirmLeave(!!res);
    //   }).catch(() => {
    //     return false;
    //   });
    // }

    // return this.confirmLeave(component.modified);
  }

  // private confirmLeave(modified: boolean) {
  //   if (!modified)
  //     return true;

  //   if (confirm('You have unsaved changes! If you leave, your changes will be lost.')) return true;
  //   else return false;
  // }
}
